(() => {
  angular
    .module('complianceFrameworkApp.core')
    .factory('httpInterceptorService', httpInterceptorService);

  /* ngInject */
  function httpInterceptorService($injector, $q, Flash, sessionService) {
    return {
      request: config => {
        if (sessionService.getImpersonatedUser()) {
          config.headers['X-Impersonated-User-Id'] = sessionService.getImpersonatedUser().id;
        }

        return config;
      },
      responseError: response => {
        if (response.status === 401) {
          if ($injector.get('$state').current.name != 'unauthenticated.login') {
            Flash.create('warning', 'Your session has expired. Please log in again to continue.');
          }

          $injector.get('$state').go('unauthenticated.login');
        } else if (response.status === 403) {
          Flash.create('danger', 'You do not have permission to access the requested resource.');
        }

        return $q.reject(response);
      }
    };
  }
})();
